export default Object.freeze({
  ANSWER_METRICS: 'AnswerMetrics',
  REVIEW: 'Review',
});
